<fieldset>
	<!-- <div class="m-error" *ngIf="incomesFormArray.hasError('minSum')">
			סכום מינימלי -  {{ incomesFormArray.getError('minSum') }}
	</div> -->
	<br />
	<app-line-other-income *ngFor="let income of incomesFormArray.controls; let i=index" [index]="i" [income]="income"
		[type]="incomeTypes" (removed)="removeArr($event)" (changeInput)="changeInput($event)"
		(clickInput)="clickInput($event)" [qID]="qID" [displayErrors]="displayErrors" [titles]="titles"
		[needSources]="needSources" (change)="emitIncomesChanges($event)" [ph]="ph"
		[displayX]="incomesFormArray.length>1">
	</app-line-other-income>
</fieldset>
<div *ngIf="!addButtonOff" class="d-flex justify-content-lg-start  justify-content-sm-center text-right ">
	<div *ngIf="incomesFormArray.length > 0 && incomesFormArray.length < maxIncomesCount" class="m-add-line-btn w-100"
		(click)="addIncome()" role="button" tabindex="0" (keypress)="simulateClick($event)">
		<span>{{buttons[1]|translate}}</span>
	</div>
	<div *ngIf="incomesFormArray.length === 0" class="m-add-line-btn w-100" (click)="addIncome()" role="button"
		tabindex="0" (keypress)="simulateClick($event)">
		<i class="fa fa-plus" aria-hidden="true"></i>
		<span>{{buttons[0]|translate}}</span>
	</div>
</div>
<br />


// WEBPACK FOOTER //
// ./src/app/incomes-array/incomes-array.component.html